module.exports = __webpack_public_path__ + "fonts/proximasoft-bold-webfont.cf47965.ttf";